game = {};
gameData = {};
gameData.gameName = "Power Pack";
gameData.gameVersionMajor = "1";
gameData.gameVersionMinor = "0";
gameData.gameVersionBugFix = "51";
gameData.gameReleaseDate = "19/05/2026"; // update me upon release

gameData.symbolWidth = 175;
gameData.canAfford = true;
gameData.symbolHeight = 135;
gameData.appertureSize = 135;
gameData.numReels = 6;
gameData.luckyBetUplift = 1.5;
gameData.numRows = 4;
gameData.slotCellCount = 24;
gameData.possibleCashValues = [25, 50, 100, 150, 200, 250, 300, 350, 400, 500];
gameData.symbolList;
gameData.playerCurrency = undefined;

gameData.prepaidSpinsLeft = undefined;

game.sideMenuOpen = false;

game.autoplayPopupOpen = false;

game.splashScreenDone = false;

game.features = [];
game.currentFeature = 0;
game.maxFeatureIndex = 3;
game.featureAnimating = false;
game.arrows = [];
game.featureAutoTimeline = undefined;

game.filterLandscapeAnim = undefined;
game.filterPortraitAnim = undefined;

let devMode = false;
Reflex.developerModeData.checkUnusuedResources = devMode;
Reflex.developerModeData.highlightTranslatedText = devMode;
Reflex.developerModeData.showButtonHitAreas = devMode;
Reflex.developerModeData.fastSpin = devMode;

Reflex.enableDeveloperMode();

game.onCreditChanged = function (creditTask) {
  gameData.credit = creditTask.data.balance;
  if (
    gdk.serverParser._inReplayMode === true &&
    gdk.serverParser._endGame === true &&
    gdk.serverParser.prepaidResultBalance !== 0
  ) {
    gameData.credit = gdk.serverParser.prepaidResultBalance;
  }

  gameData.creditMeter.set(gameData.credit);
  gameData.creditMeterMobile.set(gameData.credit);
};

game.createGameVersion = function () {
  var versionString =
    gameData.gameName +
    " v" +
    gameData.gameVersionMajor +
    "." +
    +gameData.gameVersionMinor +
    "." +
    gameData.gameVersionBugFix;
  console.log(versionString);
};

game.initialise = function (gameConfigTask) {
  // --------------------------------------------------------------------------------------------
  // All game data has been loaded, initial layout has been set, and gameData has been populated.
  // Time to link everything together.
  // --------------------------------------------------------------------------------------------
  var i;

  // Create the game version text
  game.createGameVersion();

  gameData.gameConfig = gameConfigTask.data;

  // Set initial state
  resourceManager.getController("inputOverlord").setState("enabled");

  gameData.musicManager = resourceManager.get("musicManager");
  gameData.maxmimumWin = gameConfigTask.data.slotConfig.maxmimumWin;
  gameData.stakes = [];

  for (i = 0; i < gameConfigTask.data.slotConfig.coinSizes.length; i++) {
    gameData.stakes.push(
      gameConfigTask.data.slotConfig.coinSizes[i] *
        gameConfigTask.data.slotConfig.defaultNumLines
    );
  }
  gameData.currentStakeIndex = gameConfigTask.data.slotConfig.coinSizes.indexOf(
    gameConfigTask.data.slotConfig.defaultAmountPerLine
  );

  // Hide all screens except loading. These will be shown when loading continues
  resourceManager.getContainer("gameContainer").visible = false;
  resourceManager.getContainer("DemoContainer").visible = false;
  resourceManager.getContainer("gameButtonContainer").visible = false;
  gameData.symbols = resourceManager.getConfiguration().symbols;

  const bgContainer = resourceManager.getContainer("backgroundContainer");
  bgContainer.visible = true;

  gameData.gameMask = new PIXI.Graphics();
  gameData.gameMask.beginFill(0xffffff);
  gameData.gameMask.drawRect(0, 0, 1, 1);
  bgContainer.addChild(gameData.gameMask);

  systemData.gameContainer.mask = gameData.gameMask;

  gameData.numLines = gameConfigTask.data.slotConfig.defaultNumLines;
  gameData.potData = gameConfigTask.data.potData;

  gameData.creditMeter = resourceManager.get("creditContainer:creditMeter");
  gameData.creditMeterMobile = resourceManager.get(
    "creditContainer:creditMeterMobile"
  );
  gameData.winningsMeter = resourceManager.get(
    "winningsContainer:winningsMeter"
  );
  gameData.winningsMeterMobile = resourceManager.get(
    "winningsContainer:winningsMeterMobile"
  );
  gameData.stakeMeter = resourceManager.get("betContainer:BetMeter");
  gameData.stakeMeterMobile = resourceManager.get(
    "betContainer:BetMeterMobile"
  );

  gameData.gameMathsVersion = gameConfigTask.data.mathsVersion;

  messageBus.subscribe("common:BalanceEvent", game.onCreditChanged);
  messageBus.subscribe("game:modal", game.modal);
  messageBus.subscribe("game:sideMenuOpen", game.sideMenuOpenMsg);
  messageBus.subscribe("game:sideMenuClosed", game.sideMenuClosedMsg);
  Reflex.registerEventHandler("resize", game.onResize);
  Reflex.registerEventHandler("orientationChange", game.onOrientationChange);
  messageBus.subscribe("game:backFromReplay", game.backFromReplay);
  messageBus.subscribe("spinner:GameConfigEvent", game.onGameConfigEvent);

  gameController.initialise(gameConfigTask);

  // Kick off the game
  game.onOrientationChange();
  game.onResize();
  gameController.start();
};

game.onGameConfigEvent = function () {
  if (gameData.recoveryStake) {
    gameData.stakeMeter.set(gameData.recoveryStake);
    gameData.stakeMeterMobile.set(gameData.recoveryStake);

    if (gameData.gameConfig.slotConfig.recoverGB) {
      resourceManager.get("goldenBetToggleButton").setRecovery();
      gameData.encoreEnabled = true;
    }
  }
};

game.changeStake = function (stake) {
  if (stake !== undefined) {
    gdk.playerChangedStake(stake);
  }
};

game.sideMenuOpenMsg = function () {
  game.sideMenuOpen = true;
};

game.sideMenuClosedMsg = function () {
  game.sideMenuOpen = false;
};

game.onResize = function () {
  if (gameData.gameMask) {
    if (systemData.isLandscape) {
      gameData.gameMask.scale.x = 1280;
      gameData.gameMask.scale.y = 720;
    } else {
      gameData.gameMask.scale.x = 720;
      gameData.gameMask.scale.y = 1280;
    }
  }
};

game.onOrientationChange = function () {
  if (game.slideShowActive) {
    game.updateSplashScreen();
  }
};

game.onCloseTutorial = function () {};

game.addNonNumpadSpeedControl = function () {
  if (!gdk.isDevelopmentBuild()) {
    Reflex.developerModeData.keyDownCallbacks.push(function (keycode) {
      if (!Reflex.developerModeData.manipulateCredit) {
        switch (keycode) {
          case 32: {
            // Pause/break key
            Reflex.gamePaused = !Reflex.gamePaused;
            break;
          }
          case 48: {
            // Keypad 0
            Reflex.gamePaused = !Reflex.gamePaused;
            break;
          }
          case 49: {
            // Keypad 1
            Reflex.developerModeData.speedModifier = 0.0625;
            break;
          }
          case 50: {
            // Keypad 2
            Reflex.developerModeData.speedModifier = 0.125;
            break;
          }
          case 51: {
            // Keypad 3
            Reflex.developerModeData.speedModifier = 0.25;
            break;
          }
          case 52: {
            // Keypad 4
            Reflex.developerModeData.speedModifier = 0.5;
            break;
          }
          case 53: {
            // Keypad 5
            Reflex.developerModeData.speedModifier = 1.0;
            break;
          }
          case 54: {
            // Keypad 6
            Reflex.developerModeData.speedModifier = 2.0;
            break;
          }
          case 55: {
            // Keypad 7
            Reflex.developerModeData.speedModifier = 4.0;
            break;
          }
          case 56: {
            // Keypad 8
            Reflex.developerModeData.speedModifier = 8.0;
            break;
          }
          case 57: {
            // Keypad 9
            Reflex.developerModeData.speedModifier = 16.0;
            break;
          }
          case 58: {
            // * key
            Reflex.developerModeData.speedModifier += 0.05;
            break;
          }
          case 59: {
            // / Key
            Reflex.developerModeData.speedModifier -= 0.05;
            break;
          }
          default:
            break;
        }

        if (Reflex.developerModeData.speedModifier > 256)
          Reflex.developerModeData.speedModifier = 256;
        if (Reflex.developerModeData.speedModifier < 0.00390625)
          Reflex.developerModeData.speedModifier = 0.00390625;

        if (Reflex.gamePaused || Reflex.platformPaused) {
          soundManager.pauseAllSounds();
        } else {
          soundManager.resumeAllSounds();
        }
        soundManager.setTimeScale(Reflex.developerModeData.speedModifier);
        PIXI.ticker.shared.speed = Reflex.developerModeData.speedModifier;
      }
    });
  }
};

game.disableSplashBackgrounds = function (background, portrait_background) {
  //background.visible = false;
  background.interactive = false;
  background.on("mouseup", function () {});
  background.on("touchend", function () {});
  // portrait_background.visible = false;
  portrait_background.interactive = false;
  portrait_background.on("mouseup", function () {});
  portrait_background.on("touchend", function () {});
};

game.swapFeature = function (direction) {
  if (game.featureAnimating) return;

  game.featureAnimating = true;

  game.arrows.forEach((arrow) => {
    arrow.alpha = 0.7;
  });

  const duration = 0.2;
  const offset = 100;
  const oldCont = game.features[game.currentFeature];

  gsap.to(oldCont, {
    duration,
    x: offset * direction,
    alpha: 0,
    onComplete: () => {
      oldCont.visible = false;
    },
  });

  game.currentFeature += direction;

  if (game.currentFeature < 0) {
    game.currentFeature = game.maxFeatureIndex;
  } else if (game.currentFeature > game.maxFeatureIndex) {
    game.currentFeature = 0;
  }

  const newCont = game.features[game.currentFeature];
  newCont.x = offset * -direction;
  newCont.visible = true;

  gsap.to(newCont, {
    duration,
    delay: duration / 2,
    x: 0,
    alpha: 1,
    onComplete: () => {
      game.featureAnimating = false;
      game.arrows.forEach((arrow) => {
        arrow.alpha = 1;
      });
    },
  });
};

game.showCurrentFeature = function () {
  game.features.forEach((feature) => {
    feature.visible = false;
    feature.alpha = 0;
  });

  game.features[game.currentFeature].visible = true;
  game.features[game.currentFeature].alpha = 1;
};

game.goToSplash = function () {
  if (!game.splashScreenDone) {
    game.splashScreenDone = true;
    resourceManager.getContainer("loadingbackgroundContainer").visible = false;
    resourceManager.getContainer("splashContainer").visible = true;

    game.features.push(resourceManager.get("featuresContainer:wildPanel"));
    game.features.push(resourceManager.get("featuresContainer:powerPackPanel"));
    game.features.push(resourceManager.get("featuresContainer:freespinsPanel"));
    game.features.push(resourceManager.get("featuresContainer:cashLinkPanel"));
    resourceManager.getContainer("helpPageScrollContainer").visible = true;

    gameData.helpPageScroll = resourceManager.get(
      "helpPageScrollContainer:helpPageScroll"
    );
    gameData.winningsText = resourceManager.get("winningsText");

    game.showCurrentFeature();

    game.featureAutoTimeline = gsap.timeline({ repeat: -1 }).call(
      () => {
        game.swapFeature(-1);
      },
      undefined,
      "<+=5"
    );

    let arrowLeft = resourceManager.get("featuresContainer:arrowLeft");
    let arrowRight = resourceManager.get("featuresContainer:arrowRight");

    game.arrows.push(arrowLeft);
    game.arrows.push(arrowRight);

    arrowLeft.interactive = true;
    arrowRight.interactive = true;

    arrowLeft.on("mouseup", function () {
      game.swapFeature(1);
      game.featureAutoTimeline.pause();
      return;
    });
    arrowLeft.on("touchend", function () {
      game.swapFeature(1);
      game.featureAutoTimeline.pause();
      return;
    });
    arrowLeft.on("mouseover", function () {
      return;
    });

    arrowRight.on("mouseup", function () {
      game.swapFeature(-1);
      game.featureAutoTimeline.pause();
      return;
    });
    arrowRight.on("touchend", function () {
      game.swapFeature(-1);
      game.featureAutoTimeline.pause();
      return;
    });
    arrowRight.on("mouseover", function () {
      return;
    });

    let background = resourceManager.get("landscapeBackground");
    let portrait_background = resourceManager.get("portraitBackground");
    background.interactive = true;
    portrait_background.interactive = true;

    background.on("mouseup", function () {
      game.disableSplashBackgrounds(background, portrait_background);
      game.goToGame();
    });
    background.on("touchend", function () {
      game.disableSplashBackgrounds(background, portrait_background);
      game.goToGame();
    });

    portrait_background.on("mouseup", function () {
      game.disableSplashBackgrounds(background, portrait_background);
      game.goToGame();
    });
    portrait_background.on("touchend", function () {
      game.disableSplashBackgrounds(background, portrait_background);
      game.goToGame();
    });
    if (!gdk.getPlatformAllowsSplashScreen()) {
      game.disableSplashBackgrounds(background, portrait_background);
      game.goToGame();
    }
  }
};

game.checkShouldShowPaytableAfterSplash = function () {
  let license;

  if (gameData.license === "" || gameData.license === undefined) {
    gameData.license === "default";
  }

  license = gameData.license.toUpperCase();

  if (license === "BR" && !gameController.gameRecovering) {
    return true;
  }
  return false;
};

game.resetWinnings = function () {
  gameController.winningsContainer.visible = false;
  gameData.winningsMeter.set(0);
  gameData.winningsMeterMobile.set(0);
  gameController.winlinePopup.visible = false;
  gameController.stopCyclingWins();
};

game.goToGame = function () {
  let license;

  if (gameData.license === "" || gameData.license === undefined) {
    gameData.license === "default";
  }

  license = gameData.license.toUpperCase();

  if (license !== "BR") {
    gdk.loadingClosed();
  }

  if (bowser.chrome && bowser.android) {
    var chromeVersion = Number(
      String(bowser.version).substring(0, String(bowser.version).indexOf("."))
    );
    if (chromeVersion >= 55) {
      // Chrome will only start audio on a touch
      Howler.ctx.resume();
    }
  }

  game.slideShowActive = false;
  timerManager.stop(game.slideshowTimer);
  soundManager.stop("splash_screen");

  gameData.musicManager.setUpSounds();

  game.featureAutoTimeline.pause();

  gameData.winningsText = resourceManager.get("winningsText");
  resourceManager.getContainer("splashContainer").visible = false;
  resourceManager.getContainer("gameContainer").visible = true;
  resourceManager.getContainer("DemoContainer").visible = true;
  resourceManager.getContainer("gameButtonContainer").visible = true;
  resourceManager.getContainer("stakeSelectionContainer").visible = true;
  resourceManager.getContainer("backgroundContainer").visible = true;
  resourceManager.getContainer("PopupMaskContainer").visible = true;
  resourceManager.getContainer("mobileMeterPanel").visible = true;

  resourceManager.getContainer("featureUIContainer").visible = true;
  resourceManager.getContainer("popupContainer").visible = true;

  // make this true to see what sounds are playing
  resourceManager.getContainer("soundTrack").visible = false;

  game.onOrientationChange();

  game.overrideButtons();

  if (!Reflex.developerMode && gdk.deviceInfo.mobile && !gdk.isFullscreen()) {
    gdk.requestFullscreen();
  }

  if (gameController.gameRecovering) {
    gameController.initNewGame();
  }
};

game.overrideButtons = function () {
  game.addNonNumpadSpeedControl();

  const autoplayController =
    resourceManager.getController("autoplayController");

  const baseStart = autoplayController.start;
  const baseCancel = autoplayController.cancel;

  autoplayController.start = function () {
    soundManager.play("buttonPressed");
    baseStart();
  };

  autoplayController.cancel = function () {
    if (game.autoplayPopupOpen) {
      soundManager.play("buttonPressed");
    }
    baseCancel();
  };

  const spinButton = resourceManager.get("spinButton");
  spinButton.canEnableBase = spinButton.canEnable;
  spinButton.canEnable = function () {
    return (
      this.canEnableBase() &&
      !gdk.serverParser._inReplayMode &&
      !gdk.serverParser._inRewatchMode &&
      !game.sideMenuOpen
    );
  };
  spinButton.playSound = function () {
    if (!gameController.inFreeSpins && !gameController.wasCashLink) {
      gameData.musicManager.increaseBaseLevel();
    }

    const spinButtonSounds = ["spinButton1", "spinButton2", "spinButton3"];
    const randIndex = Math.floor(Math.random() * spinButtonSounds.length);
    soundManager.play(spinButtonSounds[randIndex]);
  };

  const autoplayButton = resourceManager.get(
    "uiContainer:buttonContainer:autoplayButton"
  );
  autoplayButton.baseCanEnable = autoplayButton.canEnable;
  autoplayButton.canEnable = function () {
    return (
      this.baseCanEnable() &&
      !game.sideMenuOpen &&
      !gdk.serverParser._inReplayMode &&
      !gdk.serverParser._inRewatchMode
    );
  };
  const stakeButton = resourceManager.get("uiContainer:buttonContainer:stake");

  stakeButton.baseCanEnable = stakeButton.canEnable;
  stakeButton.canEnable = function () {
    return (
      this.baseCanEnable() &&
      !game.sideMenuOpen &&
      !gdk.serverParser._inReplayMode &&
      !gdk.serverParser._inRewatchMode
    );
  };

  const volumeButton = resourceManager.get("volume");
  volumeButton.baseCanEnable = volumeButton.canEnable;
  volumeButton.canEnable = function () {
    return (
      this.baseCanEnable() &&
      !game.sideMenuOpen &&
      !gdk.serverParser._inRewatchMode
    );
  };
};

game.modal = function (task) {
  if (task.reason === "autoplay") {
    game.autoplayPopupOpen = true;
  } else if (task.reason === undefined || task.reason === "") {
    game.autoplayPopupOpen = false;
  }
};

game.onHelpPagesClosed = function () {};

game.onOptionsButtonPressed = function () {};

game.onAutoplayDialogCancelled = function () {};

game.onAutoplayDialogConfirmed = function () {
  gameController.startAutoplay();
};

game.backFromReplay = function (data) {
  if (
    soundManager.sharedMode === true // we have been sharing the soundManager
  ) {
    // im going to assume the back button has been pressed during watching a replay
    // the ygg platform is telling us to unmute audio
    // stop any sounds currently playing from the old replay game
    // then clear the sharedMode flag
    // we need to restore what audio and what levels they were playing at
    // this will be down to each client to handle this as ids are stored all over the place
    // the music managers are inconsistant
    soundManager.stopAllSounds();
    soundManager.sharedMode = false;
    messageBus.post("sounds:restorePreviouslyPlayingAudio", {
      reason: "back from replay",
    });
  }
};
